
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/campaigner",
      function () {
        return require("private-next-pages/destinations/campaigner.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/campaigner"])
      });
    }
  